import React, { useEffect, useState } from "react";
import './ClockComponent.css';

function ClockComponent() {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [is24HourFormat, setIs24HourFormat] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const toggleFormat = () => {
    setIs24HourFormat(!is24HourFormat);
  };

  const hours = is24HourFormat ? currentTime.getHours() : currentTime.getHours() % 12 || 12;
  const minutes = currentTime.getMinutes().toString().padStart(2, "0");
  const seconds = currentTime.getSeconds().toString().padStart(2, "0");
  const ampm = currentTime.getHours() >= 12 ? "PM" : "AM";

  const formattedTime = `${hours}:${minutes}:${seconds}`;
  const formattedDate = currentTime.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric"
  });

  const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const currentDay = weekDays[currentTime.getDay()];

  // Calculate the rotation for the analog clock hands
  const hourDegrees = (currentTime.getHours() % 12) * 30 + currentTime.getMinutes() * 0.5;
  const minuteDegrees = currentTime.getMinutes() * 6;
  const secondDegrees = currentTime.getSeconds() * 6;

  return (
    <div className="clock-container-clock">
      <div className="clock-body-clock">
        <div className="clock-face-clock">
          <div className="clock-numbers-clock">
            <span className="number number12-clock">12</span>
            <span className="number number3-clock">3</span>
            <span className="number number6-clock">6</span>
            <span className="number number9-clock">9</span>
          </div>
          <div className="clock-hand hour-hand" style={{ transform: `rotate(${hourDegrees}deg)` }}></div>
          <div className="clock-hand minute-hand" style={{ transform: `rotate(${minuteDegrees}deg)` }}></div>
          <div className="clock-hand second-hand" style={{ transform: `rotate(${secondDegrees}deg)` }}></div>
        </div>
        <div className="digital-clock-clock">
          <div className="time-clock">
            <span className="hours-clock">{formattedTime}</span>
            {!is24HourFormat && <span className="ampm-clock">{ampm}</span>}
          </div>
          <div className="date-clock">
            {formattedDate}
          </div>
          <div className="week-bar-clock">
            {weekDays.map((day) => (
              <div key={day} className={`week-day-clock ${day === currentDay ? 'active-clock' : ''}`}>
                {day.slice(0, 3)}
              </div>
            ))}
          </div>
          <div className="format-switcher-clock">
            <label className="switch-clock">
              <input type="checkbox" checked={is24HourFormat} onChange={toggleFormat} />
              <span className="slider-clock"></span>
            </label>
            <span className="switch-label-clock">24-hour format</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClockComponent;
